function renderHtml(container) {
  container.classList.add('hidden');
  setTimeout(() => {
    container.querySelector(`.loox-float-toggler`).innerText = 'CONSIGUE 5€';
    container.classList.remove('hidden');
  }, 2000);

}
window.addEventListener("DOMContentLoaded", (event) => {
  const bodyPage = document.querySelector('body');
  let observer = new MutationObserver(mutations => {
    for(let mutation of mutations) {
      for(let node of mutation.addedNodes) {
        if(node.classList.contains('loox-float-toggler-container')){
          renderHtml(node);
        }
      }
    }
  });
  observer.observe(bodyPage, {
    childList: true,
    subtree: false
  });
});